const SERVER_URL = "https://anjalikp-website-backend-development-nodejs-2mk6mheziq-uc.a.run.app/"
  const IMAGE_URL = 
  "https://storage.googleapis.com/cdn-roundtechsquare/"
module.exports = {
  SERVER_URL,IMAGE_URL
};